import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import useFreeAccountStatus from '../../hooks/useFreeAccountStatus';
import { shareOffer } from '../../utils/share';
import { trackAcquisitionEvent } from '../../utils/acquisitionEvents';
import '../../styles/OwnerOffer.css';

const VIEWED_KEY = 'adwary_owner_offer_viewed';

function OwnerOffer({ onRegister }) {
  const { status, hasFreeLeft } = useFreeAccountStatus();

  useEffect(() => {
    try {
      if (sessionStorage.getItem(VIEWED_KEY)) return;
      sessionStorage.setItem(VIEWED_KEY, 'true');
    } catch {
      // Event tracking still works when storage is unavailable.
    }
    trackAcquisitionEvent('offer_viewed', '/welcome');
  }, []);

  const handleShare = async () => {
    trackAcquisitionEvent('offer_shared', '/welcome');
    const result = await shareOffer();
    if (result === 'copied') toast.success('تم نسخ رابط العرض');
    if (result === 'unavailable') toast.error('تعذر فتح المشاركة');
  };

  return (
    <section className={`owner-offer ${status && !hasFreeLeft ? 'owner-offer--full' : ''}`}>
      <span className="owner-offer-badge">عرض الإطلاق لأصحاب المصالح</span>
      <h2 className="owner-offer-title">
        {status
          ? `6 أشهر مجاناً لأول ${status.total} مصلحة`
          : 'ابدأ إدارة حجوزات مصلحتك مع أدواري'}
      </h2>

      {status && hasFreeLeft && (
        <p className="owner-offer-availability">
          متبقٍ <strong>{status.remaining}</strong> من أصل {status.total} حساب مجاني
        </p>
      )}
      {status && !hasFreeLeft && (
        <p className="owner-offer-availability">
          اكتمل العرض المجاني — يمكنك تقديم طلب للانضمام إلى قائمة الانتظار
        </p>
      )}

      <ul className="owner-offer-benefits">
        <li>حجوزات أونلاين لعملائك</li>
        <li>إدارة المواعيد وجدول العمل</li>
        <li>تذكيرات تساعد على تقليل الغياب</li>
      </ul>
      <p className="owner-offer-trust">
        لا نطلب بيانات دفع. سنراجع طلبك ونتواصل معك لإعداد الحساب.
      </p>

      <div className="owner-offer-actions">
        <button type="button" className="owner-offer-primary" onClick={onRegister}>
          اطلب الانضمام الآن
        </button>
        <button type="button" className="owner-offer-share" onClick={handleShare}>
          شارك العرض عبر واتساب
        </button>
      </div>
    </section>
  );
}

export default OwnerOffer;
